import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react"; //Limitless imports

import { useCustomerContext } from "../customer/CustomerContext";
import { useNotificationContext } from "../../../common/hooks";
import { MESSAGE_STATE_LOADING } from "../../utils/customer-message-state-engine/CustomerMessageStateConstants";
import { createCustomerMessage, fetchCustomerMessage, acceptExpertAnswer, submitMessageScore, submitMessageTestimonial, createDialogue, escalateCustomerMessage, reportCustomerMessage } from "../../apis/customer-message-api/CustomerMessageAPI";
import { calculatePublicMessageState } from "../../utils/customer-message-state-engine/CustomerMessageStateEngine";
import { useCustomerHistoryContext } from "../customer-history/CustomerHistoryContext";
var INITIAL_STATE = {
  loading: false,
  typing: false,
  dialogues: [],
  footerState: MESSAGE_STATE_LOADING,
  expertAuthors: {},
  custScoreScheme: {
    name: "3-faces",
    maxScore: 3,
    resolvedThreshold: 3
  }
};
export var useCustomerMessage = function useCustomerMessage() {
  var _React$useState = React.useState(INITIAL_STATE),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      message = _React$useState2[0],
      setMessage = _React$useState2[1];

  var _useCustomerHistoryCo = useCustomerHistoryContext(),
      updateHistoryMessage = _useCustomerHistoryCo.updateHistoryMessage,
      addMessageToHistory = _useCustomerHistoryCo.addMessageToHistory;

  var _useCustomerContext = useCustomerContext(),
      updateCustomerEmailHashAndClearQuestion = _useCustomerContext.updateCustomerEmailHashAndClearQuestion,
      getCustomerData = _useCustomerContext.getCustomerData;

  var _useNotificationConte = useNotificationContext(),
      addFailureNotification = _useNotificationConte.addFailureNotification;

  var updateMessage = function updateMessage(messageProps) {
    var newMessage = _objectSpread({}, message, {}, messageProps);

    setMessage(newMessage);
  };

  var createMessage = function createMessage(customer, createCallback) {
    setMessage(_objectSpread({}, INITIAL_STATE, {
      loading: true
    }));
    createCustomerMessage(customer, function (result) {
      if (!result.hasError) {
        fetchMessage(result.messageId, result.accessKey);
        updateCustomerEmailHashAndClearQuestion(result.customerEmailHash);
        createCallback(result);
      } else {
        setMessage(_objectSpread({}, message, {
          loading: false
        }));
        addFailureNotification("Unable to create message");
      }
    });
  };

  var fetchMessage = function fetchMessage(messageId, accessKey, overrideCustConfirmation, overrideAccepted) {
    fetchCustomerMessage(messageId, accessKey, function (result) {
      if (!result.hasError) {
        if (overrideCustConfirmation === "true") {
          result.custConfirmation = true;
        }

        if (overrideAccepted === "true") {
          result.accepted = true;
          result.acceptedDate = new Date().getTime();
        }

        var _calculatePublicMessa = calculatePublicMessageState(result),
            footerState = _calculatePublicMessa.footerState;

        result.footerState = footerState; //finish loading

        result.loading = false; //clear fields used to derive typing

        result.typing = false;
        result.claimer = "";
        result.claimedAt = null;
        setMessage(result);
        addMessageToHistory(result);
      } else {
        setMessage(_objectSpread({}, message, {
          loading: false
        }));
        addFailureNotification("Unable to retreive message");
      }
    });
  };

  var recalculateMessageState = function recalculateMessageState() {
    var _calculatePublicMessa2 = calculatePublicMessageState(message),
        footerState = _calculatePublicMessa2.footerState;

    updateMessageState(footerState);
  };

  var updateMessageState = function updateMessageState(state) {
    setMessage(_objectSpread({}, message, {
      footerState: state
    }));
  };

  var acceptAnswer = function acceptAnswer(hasAccepted, callback) {
    acceptExpertAnswer(message, hasAccepted, function (result) {
      manageMutationResponse(result, "Unable to accept answer");

      if (typeof callback === "function") {
        callback();
      }
    });
  };

  var submitScore = function submitScore(score, callback) {
    submitMessageScore(message, score, function (result) {
      manageMutationResponse(result, "Unable to submit score");

      if (typeof callback === "function") {
        callback();
      }
    });
  };

  var submitTestimonial = function submitTestimonial(testimonial) {
    submitMessageTestimonial(message, testimonial, function (result) {
      if (!result.hasError) {
        setMessage(result);
        updateHistoryMessage(result);
      } else {
        addFailureNotification("Unable to submit testimonial");
      }
    });
  };

  var reportMessage = function reportMessage(callback) {
    reportCustomerMessage(message, function (result) {
      if (!result.hasError) {
        setMessage(result);
        updateHistoryMessage(result);
        callback();
      } else {
        addFailureNotification("Unable to report message");
      }
    });
  };

  var escalateMessage = function escalateMessage() {
    escalateCustomerMessage(message, function (result) {
      if (!result.hasError) {
        setMessage(result);
      } else {
        addFailureNotification("Unable to escalate message");
      }
    });
  };

  var manageMutationResponse = function manageMutationResponse(result, failureNotification) {
    if (!result.hasError) {
      var _calculatePublicMessa3 = calculatePublicMessageState(result),
          footerState = _calculatePublicMessa3.footerState;

      var newMessage = _objectSpread({}, result, {
        footerState: footerState
      });

      setMessage(_objectSpread({}, message, {}, newMessage));
      updateHistoryMessage(newMessage);
    } else {
      addFailureNotification(failureNotification);
    }
  };

  var addDialogue = function addDialogue(body, callback) {
    if (body.length > 10000) {
      addFailureNotification("lengh should be <= 10000");
    } else {
      var customer = getCustomerData();
      var tempDialogueId = Math.random();
      var dialogue = {
        dialogueId: tempDialogueId,
        body: body,
        author: customer.name,
        origin: "customer",
        type: "customer"
      };

      var newDialogues = _toConsumableArray(message.dialogues);

      newDialogues.push(dialogue);

      var newTempMessage = _objectSpread({}, message);

      newTempMessage.dialogues = newDialogues;
      setMessage(newTempMessage);
      callback();
      createDialogue(message, customer, body, function (result) {
        if (!result.hasError) {
          var newMessage = _objectSpread({}, message);

          var platformDialogue = result;
          platformDialogue.tempId = tempDialogueId;
          platformDialogue.dialogueId = tempDialogueId;
          newMessage.dialogues.push(platformDialogue);
          setMessage(newMessage);
        } else {
          addFailureNotification("Unable to post reply at this time");
        }
      });
    }
  };

  var setTyping = function setTyping(name, userName) {
    setMessage(_objectSpread({}, message, {
      typing: true,
      claimer: name,
      claimedBy: userName
    }));
  };

  var clearTyping = function clearTyping() {
    setMessage(_objectSpread({}, message, {
      typing: false,
      claimer: "",
      claimedAt: ""
    }));
  };

  var clearMessage = function clearMessage() {
    setMessage(INITIAL_STATE);
  };

  return {
    message: message,
    updateMessage: updateMessage,
    createMessage: createMessage,
    fetchMessage: fetchMessage,
    clearMessage: clearMessage,
    acceptAnswer: acceptAnswer,
    updateMessageState: updateMessageState,
    recalculateMessageState: recalculateMessageState,
    submitScore: submitScore,
    submitTestimonial: submitTestimonial,
    addDialogue: addDialogue,
    reportMessage: reportMessage,
    escalateMessage: escalateMessage,
    setTyping: setTyping,
    clearTyping: clearTyping
  };
};